import MonitorsAndAlerts from './MonitorsAndAlerts'
import DailyLogbookEvents from './DailyLogbookEvents'
import DailyLogbookStatus from './DailyLogbookStatus'
import DataBrowser from './DataBrowser'
import LogbookForm from './LogbookForm'
import SeaLice from './SeaLice'
import SlaMonitor from './SlaMonitor'
import EnvironmentMonitor from './EnvironmentMonitor'
import Logbook from './Logbook'
import SensorsMonitor from './SensorsMonitor'
import MyLog from './MyLog'
import MyJobs from './MyJobs'
import MyJobsDataViewer from './MyJobsDataViewer'
import ProjectedSitesManager from './ProjectedSitesManager'
import ManagementUI from './ManagementUI'
import LookupTables from './LookupTables'
import JobsTriggers from './JobsTriggers'
import PdfReports from './PdfReports'

const APPLICATIONS = {
  APP_SEA_LICE: SeaLice,
  APP_FEEDING_MODULE: SlaMonitor,
  APP_ENVIRONMENT_MONITOR: EnvironmentMonitor,
  APP_LOGBOOK: Logbook,
  APP_SENSORS_MONITOR: SensorsMonitor,
  APP_DAILY_LOGBOOK_STATUS: DailyLogbookStatus,
  APP_DAILY_LOGBOOK: DailyLogbookEvents,
  APP_DATA_BROWSER: DataBrowser,
  APP_LOGBOOK_FORM: LogbookForm,
  APP_MONITORS_AND_ALERTS: MonitorsAndAlerts,
  APP_DAILY_LOGBOOK_MY_LOGS: MyLog,
  APP_MY_JOBS: MyJobs,
  APP_MY_JOBS_DATA_VIEWER: MyJobsDataViewer,
  APP_PROJECTED_SITES_MANAGER: ProjectedSitesManager,
  APP_MANAGEMENT_UI: ManagementUI,
  APP_LOOKUP_TABLES: LookupTables,
  APP_JOBS_TRIGGERS: JobsTriggers,
  APP_PDF_REPORTS_LIBRARY: PdfReports,
}

export default APPLICATIONS
